export default "__VITE_ASSET__C8kCN_Hx__"